import React from 'react';

import classes from './Button.module.scss';

const button = props => {
    const buttonClass = type => {
        switch (type) {
            case 'accept':
                return classes.ButtonAccept;
            case 'cancel':
                return classes.ButtonReject;
            case 'default-white':
                return classes.ButtonDefaultWhite;
            default:
                return classes.ButtonDefault;
        }
    }
    return <button
        className = { buttonClass(props.type)  }
        onClick = { props.clicked } > { props.children }</button>
};

export default button;